module.exports = __webpack_public_path__ + "static/media/whatsapp-sticky.9f8c90d6.svg";